import { render, staticRenderFns } from "./InboxDetail.vue?vue&type=template&id=f5844dd0&scoped=true&"
import script from "./InboxDetail.vue?vue&type=script&lang=js&"
export * from "./InboxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5844dd0",
  null
  
)

export default component.exports